import React, { useRef } from 'react';
import { useIntl } from 'react-intl-next';
import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/hooks';
import { ToolTipContent, insertEmoji } from '@atlaskit/editor-common/keymaps';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { ToolbarButton, ToolbarTooltip, EmojiIcon, useToolbarUI } from '@atlaskit/editor-toolbar';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { useEmojiPickerPopup } from './hooks/useEmojiPickerPopup';
import { EmojiPickerPopup } from './popups/EmojiPickerPopup';
export var EmojiButton = function EmojiButton(_ref) {
  var api = _ref.api;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var emojiButtonRef = useRef(null);
  var _useToolbarUI = useToolbarUI(),
    popupsMountPoint = _useToolbarUI.popupsMountPoint,
    popupsBoundariesElement = _useToolbarUI.popupsBoundariesElement,
    popupsScrollableElement = _useToolbarUI.popupsScrollableElement;
  var _useSharedPluginState = useSharedPluginStateWithSelector(api, ['emoji', 'typeAhead'], function (states) {
      var _states$emojiState, _states$emojiState2, _states$typeAheadStat;
      return {
        emojiProviderSelector: (_states$emojiState = states.emojiState) === null || _states$emojiState === void 0 ? void 0 : _states$emojiState.emojiProvider,
        emojiProviderPromise: (_states$emojiState2 = states.emojiState) === null || _states$emojiState2 === void 0 ? void 0 : _states$emojiState2.emojiProviderPromise,
        isTypeAheadAllowed: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isAllowed
      };
    }),
    emojiProviderSelector = _useSharedPluginState.emojiProviderSelector,
    emojiProviderPromise = _useSharedPluginState.emojiProviderPromise,
    isTypeAheadAllowed = _useSharedPluginState.isTypeAheadAllowed;
  var emojiPickerPopup = useEmojiPickerPopup({
    api: api,
    buttonRef: emojiButtonRef
  });
  if (!(api !== null && api !== void 0 && api.emoji)) {
    return null;
  }
  var getEmojiProvider = function getEmojiProvider() {
    if (emojiProviderSelector) {
      return Promise.resolve(emojiProviderSelector);
    }
  };
  var emojiProvider = expValEquals('platform_editor_prevent_toolbar_layout_shifts', 'isEnabled', true) ? emojiProviderPromise : getEmojiProvider();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmojiPickerPopup, {
    isOpen: emojiPickerPopup.isOpen,
    targetRef: emojiButtonRef,
    emojiProvider: emojiProvider,
    onSelection: emojiPickerPopup.handleSelectedEmoji,
    onClickOutside: emojiPickerPopup.handleClickOutside,
    onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
    onUnmount: emojiPickerPopup.onPopupUnmount,
    popupsMountPoint: popupsMountPoint,
    popupsBoundariesElement: popupsBoundariesElement,
    popupsScrollableElement: popupsScrollableElement
  }), /*#__PURE__*/React.createElement(ToolbarTooltip, {
    content: expValEquals('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true) ? /*#__PURE__*/React.createElement(ToolTipContent, {
      description: formatMessage(messages.emoji),
      keymap: insertEmoji
    }) : formatMessage(messages.emoji)
  }, /*#__PURE__*/React.createElement(ToolbarButton, {
    iconBefore: /*#__PURE__*/React.createElement(EmojiIcon, {
      label: formatMessage(messages.emoji),
      size: "small"
    }),
    ariaKeyshortcuts: "Shift+;",
    ref: emojiButtonRef,
    onClick: function onClick() {
      return emojiPickerPopup.toggle();
    },
    isSelected: emojiPickerPopup.isOpen,
    isDisabled: !isTypeAheadAllowed || !emojiProvider
  })));
};